import React, { Component } from 'react'
import { Link } from 'react-router-dom';
// import StarRatingComponent from 'react-star-rating-component';
import { connect } from 'react-redux';
// import { history } from 'react-router';
import { bindActionCreators } from 'redux';
import * as documentUploadActions from '../../../actions/documentUploadActions';
import * as specialistActions from "../../../actions/specialistActions";
import * as constant from '../../../constants/constant';
import Pagination from "react-js-pagination";
import Moment from 'react-moment';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import AppointmentDocs from '../../sitemanagement/appointmentDocs';
import $ from "jquery";
import './../../../styles/css/newDocument.css'
import * as dashboardActions from "../../../actions/dashboardActions";
import { Form, Button, Col, Container, Row, Tabs, Tab } from "react-bootstrap";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import highres from './../../../images/highres.png'
import arrow from './../../../images/arrow3.png'
import clear from './../../../images/clear.png'
import fileformat from './../../../images/fileformat.png'
import fullpage from './../../../images/fullpage.png'
import upload from './../../../images/upload.png'
import fakeCert from './../../../images/fakeCert.jpg'
import Upload from './../../miniComponents/FileUpload'
import DeleteIcon from '@material-ui/icons/Delete';
import { Avatar } from '@material-ui/core';
import CameraAltOutlined from "@material-ui/icons/CameraAltOutlined";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";

export class ProfilePicture extends Component {

    constructor(props) {
        super(props)
      console.log(this.props.ppData)
        this.state = {
              documentName: this.props.ppData.name,
              documentId: this.props.ppData._id,
              docTypeId: this.props.ppData.id,
             images : [],
             viewProPicUploadDialog: false,
             specialistImageObj: null,
             tempImageObj: null,
             tempUploadedImage: null,
             removeProfileImageDialog: false,
             defaultImageURL: null,
             file: null,
             imagePreviewUrl:"",
             patientImageObj: null,
        }
        this.updateImages = this.updateImages.bind(this)
        // this.deleteFiles = this.deleteFiles.bind(this)
        this.openModal = this.openModal.bind(this)
        this.handleClose = this.handleClose.bind(this)
        this.uploadPatientImage = this.uploadPatientImage.bind(this)
        this.deleteImage = this.deleteImage.bind(this)
        this.uploadFile = this.uploadFile.bind(this)
      }
    

    componentWillReceiveProps(nextProps){
        var state = this.state

        state.imageCopy = nextProps.specialistInfo.tempProfileImage
        ? nextProps.specialistInfo.tempProfileImage
        : "";
        this.setState(state)

    }

  //   uploadFiles(){
  //     let objDoc = {
  
  //   userId: localStorage.getItem('userId'),
  //         documentName: this.state.documentName,
  //         documentTypeId: this.props.popcData._id,
  //         docTypeId: "H",
  //   file: this.state.images
  //     }
  //     console.log(objDoc)
  //     this.props.actions.uploadSpecialistDocument(objDoc)
  //     setTimeout(()=>{
  //         this.props.goBack()
  //     },1000)
  // }


    async componentWillMount(){
        let obj = {
            userId: localStorage.getItem("userId"),
          };
          await this.props.specialistActions.getSpecialistProfileData(obj);
        
    }

    openModal(){
        this.setState({viewProPicUploadDialog: true})
    }

    
  uploadTempImage = () => {
    this.setState({
      tempUploadedImage: this.state.tempImageObj,
    });
    toast.info("Image Uploaded");
    this.handleClose();
  };

    handleClose(){
        this.setState({viewProPicUploadDialog: false})
    }

    
  handleClose2 = () => {
    this.setState({ removeProfileImageDialog: false });
  };


  
  deleteImage() {
    if (this.state.removeProfileImageDialog === true) {
    
      this.setState({
        tempUploadedImage: "",
        tempImageObj: "",
        imageToBeDeleted: true,
        imagePreviewUrl: "deleted",
      },()=>{
        console.log(this.state.tempUploadedImage, this.state.tempImageObj, this.state.imageCopy)
      });
      toast.info("Image Removed");

      this.handleClose();
      this.handleClose2();
    } else {
      this.setState({ removeProfileImageDialog: true });
    }
  }


    updateImages(newImages){
        console.log(newImages)
        let state = this.state
        state.images=newImages
        this.setState(state,()=>{
            console.log(this.state.images)
        })
        
    }

    

    uploadPatientImage(event) {
        //To change the view immediately after uploading image
        event.preventDefault();
        if (event.target.name == "image") {
          if (event.target.files.length > 0) {
           
              let reader = new FileReader();
              let file = event.target.files[0];
    
              reader.onloadend = () => {
                this.setState({
                  file: file,
                  defaultImageURL: reader.result,
                });
              };
    
              reader.readAsDataURL(file);
              // this.setState({ [event.target.name]: event.target.files[0] });
              let specialistObj = {
                file: event.target.files[0],
                userId: localStorage.getItem("userId"),
              };
    
              this.setState({
                specialistImageObj: specialistObj,
                tempImageObj: URL.createObjectURL(event.target.files[0]),
                
              });
     
            
          }
        }
      }
    
      onrenderimage() {
        if (
          this.state.imageCopy == "" ||
          this.state.imageCopy == "noUserImage.jpg"
        ) {
          if (this.state.gender.value == "Male") {
            this.state.defaultImageURL =
              constant.PRODUCTION_IMAGE_URL +
              constant.UPLOAD_FOLDER +
              constant.COMMON_FOLDER +
              "doctor_m.png";
          } else {
            this.state.defaultImageURL =
              constant.PRODUCTION_IMAGE_URL +
              constant.UPLOAD_FOLDER +
              constant.COMMON_FOLDER +
              "doctor_f.png";
          }
        } else {
          this.state.defaultImageURL =
            constant.PRODUCTION_IMAGE_URL +
            constant.UPLOAD_FOLDER +
            // "/" +
            localStorage.getItem("userId") +
            "/" +
            this.state.imageCopy;
        }
      }

      uploadFile(){
        console.log("clicked");

        this.props.specialistActions.uploadSpecialistImage(this.state.specialistImageObj);
        toast.info("Profile picture uploaded")
        this.setState({ imagePreviewUrl:"" });
        this.props.goBack()
    }
   

    render() {
        var user = localStorage.getItem("user")
        ? JSON.parse(localStorage.getItem("user"))
        : {};
        var defaultImagePath =
        user.gender == "Male"
          ? constant.PRODUCTION_IMAGE_URL +
            constant.UPLOAD_FOLDER +
            constant.COMMON_FOLDER +
            "doctor_m.png"
          : constant.PRODUCTION_IMAGE_URL +
            constant.UPLOAD_FOLDER +
            constant.COMMON_FOLDER +
            "doctor_f.png";

        return (
            <CardContent style={{display:'flex',justifyContent:'center',alignItems:'center',flexDirection:'column',padding: '0px'}}>
                                     

                                     <Dialog
                            className="propic-upload-dialog"
                            onClose={this.handleClose}
                            aria-labelledby="customized-dialog-title"
                            open={this.state.viewProPicUploadDialog}
                          >
                            <DialogContent dividers>
                              <div className="propic-upload-dialog-content">
                                <div>
                                  <Avatar
                                    src={
                                      this.state.tempUploadedImage !== "" &&
                                      this.state.tempUploadedImage !== null &&
                                      this.state.tempUploadedImage !== undefined
                                        ? this.state.tempUploadedImage
                                        : this.state.tempImageObj !== undefined &&
                                        this.state.tempImageObj !== null &&
                                        this.state.tempImageObj !== ""
                                        ? this.state.tempImageObj
                                        :this.state.imagePreviewUrl === "deleted"?
                                        <CameraAltOutlined/>
                                        : this.state.imageCopy !==
                                            "noUserImage.jpg" &&
                                          this.state.defaultImageURL
                                        ? this.state.defaultImageURL
                                        : defaultImagePath
                                    }
                                    className="propic-icon"
                                    variant="square"
                                  ></Avatar>
                                </div>
                                <div>
                                  <button className="btn btn-square propic-upload-btn btn-w-120">
                                    <input
                                      name="image"
                                      onChange={this.uploadPatientImage}
                                      onClick={(event) => {
                                        event.target.value = null;
                                      }}
                                      type="file"
                                      style={{ display: "none" }}
                                      id="avatSelect"
                                    />
                                    <label
                                      className="editimg"
                                      htmlFor="avatSelect"
                                      style={{ cursor: "pointer" }}
                                    >
                                      <span
                                        className="btn-text"
                                        style={{
                                          fontFamily: "roboto",
                                          fontSize: 13,
                                        }}
                                      >
                                        CHOOSE FILE
                                      </span>
                                      <span className=" editicon tooltip-custom fadeEffect"></span>
                                    </label>
                                  </button>
                                </div>
                                <div>
                                  <p
                                    style={{
                                      fontSize: "12px",
                                      fontFamily: "Roboto",
                                    }}
                                  >
                                    A square image that will be shown on your
                                    client portal and widgets. You can upload a
                                    JPG, GIF or PNG file (file size limit is 4
                                    MB, not smaller than 130x130)
                                  </p>
                                </div>
                              </div>
                            </DialogContent>
                            <DialogActions
                              style={{ justifyContent: "flex-end" }}
                            >
                                  {this.state.tempUploadedImage || this.state.tempImageObj ||
                              this.state.imageCopy !== "noUserImage.jpg" && this.state.imagePreviewUrl !=="deleted"  ? (
                                <div onClick={this.deleteImage}>
                                  <button
                                    className="propic-dialog-close-btn btn-w-120"
                                    
                                  >
                                    <span
                                      style={{
                                        fontFamily: "roboto",
                                        fontSize: 13,
                                      }}
                                      className="btn-text"
                                    >
                                      REMOVE IMAGE
                                    </span>
                                  </button>
                                </div>
                              ) : null}

                              {this.state.tempImageObj ? (
                                <div onClick={this.uploadTempImage}>
                                  <button
                                    className="propic-dialog-close-btn btn-w-120"
                                    // onClick={this.handleClose}
                                  >
                                    <span
                                      style={{
                                        fontFamily: "roboto",
                                        fontSize: 13,
                                      }}
                                      className="btn-text"
                                      
                                    >
                                      UPLOAD
                                    </span>
                                  </button>{" "}
                                </div>
                              ) : null}

                              <div onClick={this.handleClose}>
                                <button
                                  className="propic-dialog-close-btn btn-w-120"
                                  
                                >
                                  <span
                                    style={{
                                      fontFamily: "roboto",
                                      fontSize: 13,
                                    }}
                                    className="btn-text"
                                  >
                                    CANCEL
                                  </span>
                                </button>{" "}
                              </div>
                            </DialogActions>
                          </Dialog>

                                    
                                
        
                    <Card style={{width: '100%'}}>

                        <CardContent className="poe">
                            <Row className="card-head">
                                <img src={arrow} height="50" onClick={this.props.goBack}/>

                                <Typography variant="h4" style={{marginTop:0}}>Profile Picture</Typography>
                                
                            </Row>



                            <Row className="poe-first">
                            <Col lg={{ size: 6}}>
                                <div className="dd" style={{position:'relative'}}>

                                <div className="blue-bg profile-img-bg">
                                  <Avatar onClick={this.openModal}
                                  style={{width: 45,height:45,cursor: 'pointer'}}>
                                          {this.state.tempUploadedImage !==
                                            "" &&
                                          this.state.tempUploadedImage !==
                                            null &&
                                          this.state.tempUploadedImage !==
                                            undefined ? (
                                            <img
                                              src={this.state.tempUploadedImage}
                                            />
                                          ) : this.state.imagePreviewUrl ===
                                            "deleted" ? (
                                            <CameraAltOutlined style={{color: 'black'}} />
                                          ) : this.state.imageCopy !==
                                              "noUserImage.jpg" &&
                                            this.state.defaultImageURL ? (
                                            <img
                                              src={this.state.defaultImageURL}
                                            />
                                          ) : (
                                            <CameraAltOutlined  style={{color: 'black'}}/>
                                          )}
                                        </Avatar>
                                </div>

                      
                                </div>



                                <Dialog
                            // className="propic-upload-dialog"
                            onClose={this.handleClose2}
                            aria-labelledby="customized-dialog-title"
                            className="removePropicDialog"
                            open={this.state.removeProfileImageDialog}
                          >
                            <DialogContent
                              style={{
                                height: "200px !important",
                                padding: "0px !important",
                                backgroundColor: "#f2f2f2",
                              }}
                            >
                              <div
                                className="propic-upload"
                                style={{
                                  padding: "10px !important",
                                  backgroundColor: "#f2f2f2",
                                }}
                              >
                                <div
                                  style={{
                                    height: "60px",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    marginTop: 0,
                                    padding: 10,
                                    backgroundColor: "#fff",
                                  }}
                                >
                                  <p
                                    style={{
                                      fontSize: "16px",
                                      fontFamily: "sansation_regular",
                                      fontWeight: 500,
                                      marginBottom: 0,
                                    }}
                                  >
                                    Remove Image
                                  </p>
                                </div>
                                <div className="removal-warn">
                                  <p
                                    style={{
                                      fontSize: "16px",
                                      fontFamily: "Roboto",
                                      textAlign: "center",
                                    }}
                                  >
                                    Click on OK to remove the image
                                  </p>
                                </div>
                              </div>
                            </DialogContent>

                            <DialogActions
                              style={{
                                justifyContent: "flex-end",
                                backgroundColor: "#f2f2f2",
                              }}
                            >
                              <div>
                                <button
                                  className="propic-dialog-close-btn btn-w-120"
                                  onClick={this.handleClose2}
                                >
                                  <span
                                    style={{
                                      fontFamily: "roboto",
                                      fontSize: 13,
                                    }}
                                    className="btn-text"
                                  >
                                    CANCEL
                                  </span>
                                </button>{" "}
                              </div>

                              {this.state.tempUploadedImage || this.state.tempImageObj||
                              this.state.imageCopy !== "noUserImage.jpg" ? (
                                <div>
                                  <button
                                    className="propic-dialog-close-btn btn-w-120"
                                    onClick={this.deleteImage}
                                  >
                                    <span
                                      style={{
                                        fontFamily: "roboto",
                                        fontSize: 13,
                                      }}
                                      className="btn-text"
                                    >
                                      OK
                                    </span>
                                  </button>
                                </div>
                              ) : null}
                            </DialogActions>
                          </Dialog>









                            </Col>
                            <Col lg={6} className="filesToBeUploaded">
                                {/* <div style={{display:'flex',flexDirection:'column',flex:1,maxHeight: '350px',overflowY:'scroll'}}>
        {this.state.images && this.state.images.map((im, index)=><div className="uploadItems" key={index}>
            
            
            <p>{im.name}</p> <p onClick={(e)=>this.deleteFiles(index)}><DeleteIcon style={{color: '#8e867c'}}/></p>
            
            </div>)}</div> */}

           
            <div style={{display:'flex',justifyContent:'center',marginTop:'auto'}}>
            <button className="btn btn-square w-50" onClick={this.uploadFile}>Upload Image</button></div> 
                            </Col>

                            </Row>

                            <Row className="poe-second">
                            <Col lg={6}>
                                <Typography variant="h4">Profile Picture</Typography>
                                <p>Please upload a professional profile image of yourself. Profile image will be visible on your profile and across specialist network listings.</p>
                            
                            <p>Profile photo specifications:</p>

                            <li>JPG or PNG</li>
                            <li>4 MB file size limit</li>
                            <li>130x130 pixels or larger</li>

                            <p>Profile photo specifications:</p>

                            <li>Forward-facing, centered photo, displaying full face (shoulders-up)</li>
                            <li>No sunglasses, no obstruction, no other subjects in image</li>
                            <li>High-resolution, well-lit and in-focus</li>

                            <p>We won’t accept a driver’s license photo, identification card (ID) photo or image of a printed photo.</p>
                            </Col>

                            <Col lg={6} className="cert" style={{height:"100%",display: 'flex',justifyContent:'center',alignItems:'center',maxWidth:"80%",padding: '15px'}}>
                            <img src={fakeCert} height="300px" width="auto"/>
                            </Col>

                            </Row>




                            <Row className="poe-third">
                            <Col lg={12}>
                                <Typography variant="h4">Tips For Uploading Documents</Typography>
                                <p>Please ensure the following document tips are followed for successful verification procedures.</p>

                            </Col>
                            <Col lg={6}>
                                <img src={highres} height="30"/>
                                <h5>High Resolution</h5>
                                <p>Clear and legible scans or images</p>
                            </Col>
                            <Col lg={6}>
                                <img src={fullpage} height="30"/>
                                <h5>Full Page Visual</h5>
                                <p>Include all 4 edges of the document in the image (no cut-off portions of your document)</p>
                            </Col>
                            <Col lg={6}>
                                <img src={clear} height="30"/>
                                <h5>Upload clear & legible images</h5>
                                <p>Take well-lit clear and bright pictures of your document. Text must be easy to read. Allow your camera to focus avoiding blur and glare.</p>
                            </Col>
                            <Col lg={6}>
                                <img src={fileformat} height="30"/>
                                <h5>Accepted file formats</h5>
                                <p>Please upload PDF, JPEG or PNG formats.</p>
                            </Col>


                            </Row>


                            

                     

                        </CardContent>


                    </Card>

            








             </CardContent>
        )
    }
}

function mapStateToProps(state, ownProps) {
	return {
		specialistDocument: state.uploadDocument.specialistDocument ? state.uploadDocument.specialistDocument : [],
		totalCount: state.uploadDocument.specialistDocument ? state.uploadDocument.specialistDocument.totalCount : 0,
		success: state.uploadDocument.specialistDocument ? state.uploadDocument.specialistDocument.success : false,
		isProfileSaved: state.uploadDocument.specialistDocument ? state.uploadDocument.specialistDocument.isProfileSaved : false,
		isVettingTriggered: state.uploadDocument.specialistDocument ? state.uploadDocument.specialistDocument.isVettingTriggered : false,
		documentTypes: state.uploadDocument.userTypeData,
    specialistInfo: state.specialist.specialistProfile,
		uploadedSpecialistData: state.uploadDocument.uploadedSpecialistData,
		specialistDocumentData: state.uploadDocument.specialistDocumentData,
    docAndStatus: state.uploadDocument.docAndStatus,
	};
}
//bindActionCreators is used to bind all actions at once
function mapDispatchToProps(dispatch) {
	return {
    specialistActions: bindActionCreators(specialistActions, dispatch),
		actions: bindActionCreators(documentUploadActions, dispatch),
		logoutAction: bindActionCreators(dashboardActions, dispatch)

	};
}
export default connect(mapStateToProps, mapDispatchToProps)(ProfilePicture);